import { AccessControlGrant } from '@models/account/access-control-grant.model';
import { AccessControlScope } from '@models/account/access-control-scope.model';
import { Account } from '@models/account/account.model';
import { Contract } from '@models/account/contract.model';
import { DeliveryPoint } from '@models/account/delivery-point.model';
import { Site } from '@models/account/site.model';

import { AccessControlRoleAdapter } from './access-control-role.adapter';
import { ApiAdapter } from './adapter';

export class AccessControlGrantAdapter extends ApiAdapter<AccessControlGrant> {
  private accessControlRoleAdapter = new AccessControlRoleAdapter();

  get(json): AccessControlGrant {
    const scope = new AccessControlScope();

    scope.deliveryPoint = undefined;
    if (json['point_grid_operator_code'] && json['point_code']) {
      scope.deliveryPoint = new DeliveryPoint({
        gridOperator: json['point_grid_operator_code'],
        meteringPoint: json['point_code'],
      });
    }

    scope.contract = json['contract_id'] ? new Contract({ id: json['contract_id'] }) : undefined;
    scope.account = json['account_id'] ? new Account({ id: json['account_id'] }) : undefined;
    scope.site = json['site_id'] ? new Site({ id: json['site_id'] }) : undefined;

    const roleObj = json['role'] ? json['role'] : { id: json['role_id'], capacities: [] };
    const role = this.accessControlRoleAdapter.get({
      id: roleObj['id'],
      name: roleObj['name'],
      description: roleObj['description'],
      capacities: roleObj['capacities'].map((fullName) => ({ fullName })),
    });
    return new AccessControlGrant({ role, scope });
  }
}
